export default __webpack_public_path__ + "static/media/icon.b199ab90.svg";